import Main from '@/layout/MainLayout.vue'
import home from '@/views/system/home/index.vue'
import homeDetail from '@/views/system/home/homeDetail.vue'
import deal from '@/views/system/deal/index.vue'
import downloadCenter from '@/views/system/downloadCenter/index.vue'
import caHandle from '@/views/system/ca/index.vue'

export default [
  {
    path: '/',
    component: Main,
    redirect: '/home',
    children: [
      { path: 'home', name: 'home', component: home },
      { path: 'homeDetail', name: 'homeDetail', component: homeDetail },
      { path: 'deal', name: 'deal', component: deal },
      { path: 'download-center', name: 'downloadCenter', component: downloadCenter },
      { path: 'ca', name: 'ca', component: caHandle },
    ]
  },
]
